import { Search, X } from "lucide-react";

// Matches the existing .search-bar pattern used inline across OrganisationsPage,
// AdminCustomersPage, etc. -- extracted as a shared component so new pages
// don't have to re-hand-roll the icon + clear-button wrapper each time.
export default function SearchBar({ value, onChange, placeholder = "Search…", style }) {
  return (
    <div style={{ position: "relative", flex: 1, minWidth: 200, ...style }}>
      <Search size={14} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", pointerEvents: "none" }} />
      <input
        className="search-bar"
        style={{ width: "100%", paddingLeft: 32, paddingRight: value ? 30 : 10, height: 38, fontSize: 13, boxSizing: "border-box" }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange("")}
          style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", padding: 2 }}
        >
          <X size={13} />
        </button>
      )}
    </div>
  );
}
